import Logo from "../Header/Logo";
import { Icon } from "@iconify/react/dist/iconify.js";
import { headerData } from "../Header/Navigation/menuData";
import { Link, useLocation } from "react-router-dom";
import AnimateButton from "../../../../components/@extended/AnimateButton";

const Footer = () => {

  const location = useLocation();

  return (
    <footer className="bg-deepSlate py-10 w-[100%]">
      <div className="container mx-auto max-w-[100%] w-[100%] lg:max-w-screen-xl md:max-w-screen-md px-4">
        <div className="grid grid-cols-1 gap-y-10 gap-x-16 sm:grid-cols-2 lg:grid-cols-12 xl:gap-x-8">
          <div className='col-span-4 md:col-span-12 lg:col-span-4'>
            {/* <Logo /> */}
            <AnimateButton>
              <h5 
                onClick={() => {
                  window.open('/', '_self');
                }}  
                className="cursor-pointer  mb:text-[1.5rem] md:text-[2rem] text-black/90 max-w-[30rem] md:text-left mb:text-center "
              >{process.env.REACT_APP_APP_NAME}</h5>
            </AnimateButton>
            {/* <div className='flex items-center gap-4'>
              <Link to="#" className='hover:text-primary text-black text-3xl'>
                <Icon
                  icon="tabler:brand-facebook"
                />
              </Link>
              <Link to="#" className='hover:text-primary text-black text-3xl'>
                <Icon
                  icon="tabler:brand-twitter"
                />
              </Link>
              <Link to="#" className='hover:text-primary text-black text-3xl'>
                <Icon
                  icon="tabler:brand-instagram"
                />
              </Link>
            </div> */}
          </div>
          <div className=" mb:col-span-4 md:col-span-2 md:text-left mb: text-center">
            <h3 className="mb-4 text-2xl font-medium">Links</h3>
            <ul className="flex flex-col md:items-start mb:items-center" >
              {headerData.map((item, index) => (
                <li key={index} className={`mb-2 ${location.pathname === item.href ? 'text-primary' : 'text-black/50'} hover:text-primary w-fit`}>
                  <Link to={item.href}>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-span-2 mb:hidden md:flex">
            {/* a physical empty space is */}
          </div>
          <div className='col-span-4 md:col-span-4 lg:col-span-4'>
            <div className="flex items-center gap-2">
              <Icon
                icon="tabler:brand-google-maps"
                className="text-primary text-3xl inline-block me-2 min-w-[2rem]"
              />
              <h5 className="text-[1rem] text-black/60">2, Laide Olugbile St., Bankole Est., Magboro, Ogun State.</h5>
            </div>
            <div className="flex gap-2 mt-10">
              <Icon
                icon="tabler:phone"
                className="text-primary text-3xl inline-block me-2"
              />
              <h5 className="text-[1rem] text-black/60">+234 703 555 3225</h5>
            </div>
            <div className="flex gap-2 mt-10">
              <Icon
                icon="tabler:phone"
                className="text-primary text-3xl inline-block me-2"
              />
              <h5 className="text-[1rem] text-black/60">+234 803 694 8151</h5>
            </div>
            <div className="flex gap-2 mt-10">
              <Icon
                icon="tabler:folder"
                className="text-primary text-3xl inline-block me-2"
              />
              <h5 className="text-[1rem] text-black/60">olivesglobaltrends@gmail.com</h5>
            </div>
          </div>
        </div>

        <div className='mt-10 lg:flex items-center justify-between'>
          <h4 className='text-black/50 text-sm text-center lg:text-start font-normal'>@{new Date().getFullYear()} Agency. All Rights Reserved by <Link to={process.env.REACT_APP_SERVER_ENDPOINT ?? '#'} target="_self" className="hover:text-primary"> {process.env.REACT_APP_APP_NAME}</Link></h4>
          <div className="flex gap-5 mt-5 lg:mt-0 justify-center lg:justify-start">
            <Link to="/" className='text-black/50 text-sm font-normal hover:text-primary'></Link>
            <Link to="/" className='text-black/50 text-sm font-normal hover:text-primary'></Link>
          </div>
          <h4 className='text-black/50 text-sm text-center lg:text-start font-normal'>Created by <Link to={process.env.REACT_APP_CREATOR_URL ?? ''} target="_blank" className="hover:text-primary text-primary">{process.env.REACT_APP_CREATOR_NAME}</Link></h4>
        </div>
      </div>
    </footer>
  )
}

export default Footer;
